export type PlatformType = "hotel" | "airline";

export const getPlatformType = (hostname: string): PlatformType => {
  const normalizedHostname = hostname.toLowerCase();

  if (normalizedHostname.includes(".airline.") || normalizedHostname.startsWith("airline.")) {
    return "airline";
  }

  if (normalizedHostname.includes("localhost")) {
    const params = new URLSearchParams(window.location.search);
    if (params.get("platform") === "airline") {
      return "airline";
    }
  }

  return "hotel";
};
